import type { CloseEvent } from "~/core/models/CloseEvent.interface";

export function useSideNavigation() {
  const router = useRouter();
  const route = useRoute();

  /**
   * Navigate to the provided path.
   * Keep query parameters in new route
   * @param path the path to navigate to
   */
  async function navigateToPath(path: string) {
    await router.push({ path, query: route.query });
  }

  /**
   * Navigate to the provided path and reload the data if the event is edited.
   * @param event the close event of the side canvas
   * @param path the path to navigate to
   * @param reloadFunction the function to reload data
   */
  async function onClose(
    event: CloseEvent,
    path: string,
    reloadFunction: () => void,
  ) {
    await navigateToPath(path);

    if (event?.edited) {
      reloadFunction();
    }
  }

  return {
    navigateToPath,
    onClose,
  };
}
